/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} ShiftRecordBreakDTOType
 * @property {string} startTime - Time the break started
 * @property {string} endTime - Time the break ended
 * @property {ShiftRecordBreakType} type - Type of break
 *
 */

import { ShiftRecordBreakType } from '@/constants/booking/ShiftRecordBreakType'

/**
 * @class
 */
export default class ShiftRecordBreakDTO {
  /**
   * Create a new ShiftRecordBreakDTO.
   * @param {ShiftRecordBreakDTOType} params
   */
  constructor(params) {
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.type = params.type
  }
}
